import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import { hasCallToAction } from '../utils';

import Block from './Block';
import H2 from './H2';
import H4 from './H4';
import RichTextHtml from './RichTextHtml';
import CTAAnchor from './CTAAnchor';
import Grid from './Grid';
import Cell from './Cell';
import Tabs from './Tabs';
import MediaDisplay from './MediaDisplay';

const PageTabs = ({ content }) => (
  <Block
    id={content.primary.internal_link_id}
    py={{ mobile: 'baseUp4', tablet: 'baseUp12' }}
    px="baseUnit"
    backgroundColor={content.primary.background_color}
  >
    <Grid>
      <Cell size={1} position="relative">
        {content.primary.title1 && content.primary.title1.text && (
          <H2
            px="baseUnit"
            mb="baseUp4"
            color={
              ['coral', 'coralLight'].includes(content.primary.background_color)
                ? 'blueDark'
                : 'coral'
            }
          >
            {content.primary.title1.text}
          </H2>
        )}

        <Tabs>
          {content.items.map((item) => (
            <Block key={`tab-${item.tab_name}`} tabKey={item.tab_name}>
              <Grid valign="center">
                <Cell
                  size={{ mobile: 1, smallTablet: 1 / 2 }}
                  mb={{ mobile: 'baseUnit', smallTablet: '0' }}
                  p={{ mobile: 'baseDown2', tablet: 'baseUnit' }}
                >
                  <H4 color={item.title_text_color || 'blueDark'} mb="baseUnit">
                    {item.title1.text}
                  </H4>

                  <RichTextHtml html={item.text.html} />

                  {hasCallToAction(item) ? (
                    <Block pt="baseUp4">
                      <CTAAnchor
                        text={item.call_to_action_text.text}
                        link={item.call_to_action_link}
                        colorTheme={item.call_to_action_color}
                      />
                    </Block>
                  ) : null}
                </Cell>
                <Cell
                  size={{ mobile: 1, smallTablet: 1 / 2 }}
                  p={{ mobile: 'baseDown2', tablet: 'baseUnit' }}
                >
                  <MediaDisplay
                    content={item}
                    imageDisplay={{ mobile: 'block' }}
                  />
                </Cell>
              </Grid>
            </Block>
          ))}
        </Tabs>
      </Cell>
    </Grid>
  </Block>
);

PageTabs.propTypes = {
  content: PropTypes.shape({
    primary: PropTypes.shape({
      internal_link_id: PropTypes.string,
      title1: PropTypes.shape({
        text: PropTypes.string.isRequired,
      }).isRequired,
      background_color: PropTypes.string.isRequired,
    }).isRequired,
    items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  }).isRequired,
};

export default PageTabs;

export const query = graphql`
  fragment PageTabsFragment on PrismicPageBodyTabs {
    id
    slice_type
    primary {
      internal_link_id
      title1 {
        text
      }
      background_color
    }
    items {
      tab_name
      title1 {
        text
      }
      title_text_color
      text {
        html
      }
      video {
        title
        embed_url
        provider_name
      }
      amazon_video_path
      image {
        alt
        localFile {
          childImageSharp {
            fluid(maxWidth: 550) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
      call_to_action_color
      call_to_action_text {
        text
      }
      call_to_action_link {
        link_type
        url
        lang
        target
      }
    }
  }
`;
